import Vue from 'vue'
import Router from 'vue-router'


import Login from '../page/login'
import Signing from '../page/signing'
import signingList from '../page/signingList/signingList'
import State from '../page/state/state'
import SigningDetails from '../page/signingDetails/signingDetails.vue'

Vue.use(Router)

/* 初始路由 */
export default new Router({
	routes: [
		{
			path: '/',
			redirect:'login'
		},
		{
			path: '/login',
			component: Login
		},
		{
			path: '/login/:id',
			component: Login
		},
		{
			path: '/sign/:id',
			component: Signing,
			meta:{
				requireAuth: true
			}
		},
		{
			path: '/signingList',
			component: signingList,
			meta:{
				requireAuth: true
			}
		},
		{
			path: '/signingList/:id',
			component: signingList,
			meta:{
				requireAuth: true
			}
		},
		{
			path: '/state/:id',
			component: State,
			name:'state'
		},
		{
			path: '/signingDetails/:id',
			component: SigningDetails,
			name:'signingDetails'
		}
	]
})
